import React from "react";
import { useNavigate } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-zinc-950 grid place-items-center px-6" data-testid="payment-cancel">
      <div className="max-w-md w-full rounded-xl border border-zinc-800 bg-zinc-900/40 p-8 text-center">
        <XCircle className="w-10 h-10 mx-auto text-zinc-400" />
        <h2 className="mt-4 font-display text-xl text-zinc-100">Payment cancelled</h2>
        <p className="mt-2 text-sm text-zinc-500">You can try again anytime.</p>
        <button onClick={() => navigate("/app/plans")} className="btn-scale mt-6 h-9 px-4 rounded-md bg-white text-zinc-950 text-sm font-medium">Back to plans</button>
      </div>
    </div>
  );
}
